const actionTypes = {
  SET_ERROR: 'SET_ERROR',
  SET_ERROR_HANDLER: 'SET_ERROR_HANDLER',
  SET_ERROR_HANDLER_OFF: 'SET_ERROR_HANDLER_OFF'
};
export default actionTypes;
